'use client';

import cn from '@/helpers/utils/classNames';

interface HeadlineProps {
  children: React.ReactNode;
  className?: string;
}
export default function Headline({ children, className }: Readonly<HeadlineProps>) {
  return (
    <h1
      className={cn(
        'v2-font-sweet-sans-pro v2-font-normal v2-text-3xl v2-text-neutral-800 v2-mt-4 sm:v2-mt-0',
        className
      )}
    >
      {children}
    </h1>
  );
}
